var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.94125 11.5567C2.71747 11.3649 2.60559 11.269 2.56459 11.1549C2.52861 11.0547 2.52861 10.9451 2.56459 10.845C2.60559 10.7308 2.71747 10.6349 2.94125 10.4431L10.7061 3.78754C11.0913 3.45736 11.2839 3.29227 11.447 3.28823C11.5887 3.28471 11.7241 3.34697 11.8136 3.45686C11.9167 3.5833 11.9167 3.83698 11.9167 4.34433V8.28165C13.8735 8.62398 15.6644 9.61551 16.9953 11.1043C18.4462 12.7274 19.2489 14.8279 19.25 17.005V17.566C18.2881 16.4072 17.0871 15.47 15.7293 14.8187C14.5322 14.2444 13.2381 13.9042 11.9167 13.8146V17.6555C11.9167 18.1628 11.9167 18.4165 11.8136 18.5429C11.7241 18.6528 11.5887 18.7151 11.447 18.7116C11.2839 18.7075 11.0913 18.5424 10.7061 18.2123L2.94125 11.5567Z",
    stroke: "#3A3939",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReply);
export default __webpack_public_path__ + "static/media/IconReply.1892b8a365296edcbd2e5a91498e53eb.svg";
export { ForwardRef as ReactComponent };